import { EntityModel } from '@/interfaces'
import {
  ALL_SOCIAL_MEDIA_SETTINGS_QUERY,
  CREATE_SOCIAL_MEDIA_SETTINGS_MUTATION,
  DELETE_SOCIAL_MEDIA_SETTINGS_MUTATION,
  FORCE_DELETE_SOCIAL_MEDIA_SETTINGS_MUTATION,
  SINGLE_SOCIAL_MEDIA_SETTINGS_QUERY,
  UPDATE_SOCIAL_MEDIA_SETTINGS_MUTATION,
} from './graphql'

const cmsSocialMediaSettingsModel: EntityModel = {
  name: 'socialMediaSettings',
  namePlural: 'socialMediaSettings',
  uniqueName: 'cmsSocialMediaSettings',
  uniqueNamePlural: 'cmsSocialMediaSettings',
  path: 'cms/config/social_media_settings',
  baseUrl: '/cms/config/social_media_settings',
  translationPrefix: 'entities:cmsSocialMediaSettings.',
  getDisplayName: (values: any) => {
    return 'CMS Social Media Settings'
  },
  gql: {
    getAll: ALL_SOCIAL_MEDIA_SETTINGS_QUERY,
    getSingle: SINGLE_SOCIAL_MEDIA_SETTINGS_QUERY,
    create: CREATE_SOCIAL_MEDIA_SETTINGS_MUTATION,
    update: UPDATE_SOCIAL_MEDIA_SETTINGS_MUTATION,
    delete: DELETE_SOCIAL_MEDIA_SETTINGS_MUTATION,
    forceDelete: FORCE_DELETE_SOCIAL_MEDIA_SETTINGS_MUTATION,
  },
  attributes: {
    facebookUrl: {
      name: 'facebookUrl',
      label: 'entities:cmsSocialMediaSettings.attributes.facebookUrl.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'url',
        },
      ],
    },
    instagramUrl: {
      name: 'instagramUrl',
      label: 'entities:cmsSocialMediaSettings.attributes.instagramUrl.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'url',
        },
      ],
    },
    linkedinUrl: {
      name: 'linkedinUrl',
      label: 'entities:cmsSocialMediaSettings.attributes.linkedinUrl.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'url',
        },
      ],
    },
  },
}

export default cmsSocialMediaSettingsModel
